import { gql } from '@apollo/client';

import { prepareResponse } from '@work4all/data';

import { BzObjectRelation } from '@work4all/models/lib/Classes/BzObjectRelation.entity';
import { InputErpAnhangAttachementsRelation } from '@work4all/models/lib/Classes/InputErpAnhangAttachementsRelation.entity';
import { InputPromptResult } from '@work4all/models/lib/Classes/InputPromptResult.entity';
import { InputWartungsvertrag } from '@work4all/models/lib/Classes/InputWartungsvertrag.entity';
import { ModifyShadowServiceContractResult } from '@work4all/models/lib/Classes/ModifyShadowServiceContractResult.entity';
import { ServiceContractPosition } from '@work4all/models/lib/Classes/ServiceContractPosition.entity';
import { AddServiceContractPosTypeOfPos } from '@work4all/models/lib/Enums/AddServiceContractPosTypeOfPos.enum';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { ServiceContractDefaultTypeOfBilling } from '@work4all/models/lib/Enums/ServiceContractDefaultTypeOfBilling.enum';

const SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_FIELDS: ModifyShadowServiceContractResult<EMode.query> =
  {
    id: null,
    name: null,
    benutzerCode: null,
    serviceContractCode: null,
    insertTime: null,
    updateTime: null,
    customerCode: null,
    projectCode: null,
    createdCodes: null,
    data: {
      serviceContractDeductionKind: null,
      kindLookupId: null,
      contractId: null,
      contract: {
        id: null,
        contractNumber: null,
        headText: null,
        footerText: null,
        note: null,
      },
      amount: null,
      id: null,
      creatorUserId: null,
      creationDate: null,
      terminationDate: null,
      nextInvoiceDate: null,
      permanentInvoice: null,
      endCustomerContactId: null,
      endCustomerSdObjMemberId: null,
      groupId: null,
      costCenterId: null,
      name: null,
      addition: null,
      mainAddressDepartmentId: null,
      mainAddressContactId: null,
      mainAddressSdObjMemberId: null,
      deliveryAddressDepartmentId: null,
      deliveryAddressContactId: null,
      deliveryAddressSdObjMemberId: null,
      additionalAddress2DepartmentId: null,
      additionalAddress2ContactId: null,
      additionalAddress2SdObjMemberId: null,
      note: null,
      number: null,
      positionList: [
        {
          factor: null,
          amountDecimal: null,
          amountSupplier: null,
          positionKind: null,
          articleId: null,
          articleNumber: null,
          comment: null,
          id: null,
          localId: null,
          date: null,
          purchasePrice: null,
          ekPreis2: null,
          free1: null,
          free2: null,
          free3: null,
          free4: null,
          free5: null,
          validFrom: null,
          validUntilDate: null,
          manufacturerNumber: null,
          index: null,
          insertTime: null,
          costCenterId: null,
          costCenter: {
            id: null,
            name: null,
            number: null,
          },
          shortText: null,
          longtext: null,
          supplierId: null,
          supplierText: null,
          number: null,
          price: null,
          price2: null,
          price2StartDate: null,
          percent: null,
          discount: null,
          updateTime: null,
          servicePricePerYear: null,
          serviceContractId: null,
          supplier: { id: null, name: null },
          article: {
            id: null,
            name: null,
            longtext: null,
            unit: {
              id: null,
              name: null,
              factor: null,
            },
            maintenanceShare: null,
          },
          discount2: null,
          priceWithDiscount: null,
        },
      ],
      rythm: null,
      skonto: null,
      skontoDurationDays: null,
      languageId: null,
      serviceContractEndDate: null,
      serviceContractStartDate: null,
      paymentId: null,
      paymentDeadline: null,
      customFieldList: [
        {
          key: null,
          value: null,
        },
      ],
      mainAddress: {
        contact: {
          id: null,
          name: null,
          firstName: null,
          displayName: null,
        },
        businessPartner: {
          id: null,
          businessPartnerType: null,
          data: {
            customer: {
              id: null,
              name: null,
              number: null,
              street: null,
              city: null,
              postalCode: null,
              website: null,
              isPrivateCustomer: null,
              mainContact: {
                id: null,
              },
            },
          },
        },
      },
      projectId: null,
      project: { id: null, name: null },
      endCustomer: {
        contact: {
          id: null,
          name: null,
          firstName: null,
          displayName: null,
        },
        businessPartner: {
          id: null,
          businessPartnerType: null,
          data: {
            customer: {
              id: null,
              name: null,
              number: null,
              street: null,
              city: null,
              postalCode: null,
              website: null,
              isPrivateCustomer: null,
              mainContact: {
                id: null,
              },
            },
          },
        },
      },
      deliveryAddress: {
        contact: {
          id: null,
          name: null,
          firstName: null,
          displayName: null,
        },
        businessPartner: {
          id: null,
          businessPartnerType: null,
          data: {
            customer: {
              id: null,
              name: null,
              number: null,
              street: null,
              city: null,
              postalCode: null,
              website: null,
              isPrivateCustomer: null,
              mainContact: {
                id: null,
              },
            },
          },
        },
      },
      singlePriceTotal: null,
      priceTotal: null,
      group: { id: null, name: null },
      typeOfContract: { id: null, name: null },
      firstReceiptNumber: null,
      priceGroupId: null,
      includedMinutesPerMonth: null,
      priceGroup: { id: null, name: null },
      attachements: [
        {
          id: null,
          index: null,
          objMemberCode: null,
          insertTime: null,
          updateTime: null,
          fileInfos: {
            fileSize: null,
            fileEntityFilename: null,
            previewUrl: null,
            downloadUrl: null,
            previewMimeType: null,
            downloadMimeType: null,
          },
        },
      ],
      taxGroupId: null,
      language: { id: null, name: null },
      costCenter: { id: null, name: null },
      paymentKind: { id: null, note: null },
      taxGroup: { id: null, name: null },
    },
  };

export { SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_FIELDS };

const SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_GQL = prepareResponse(
  Entities.modifyShadowServiceContractResult,
  SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_FIELDS
);

export const CREATE_SHADOW_SERVICE_CONTRACT_OBJECT = gql`
mutation CreateShadowServiceContract(
  $customerCode: Int
  $apCode: Int
  $serviceContractCode: Int
  $projectCode: Int
  $name: String
) {
  createShadowServiceContract(
    customerCode: $customerCode
    apCode: $apCode
    serviceContractCode: $serviceContractCode
    projektCode: $projectCode
    name: $name
  ) {
    ${SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_GQL}
  }
}
`;

export const MODIFY_SHADOW_SERVICE_CONTRACT_OBJECT = gql`
mutation ModifyShadowServiceContract(
  $id: ID!
  $serviceContract: InputWartungsvertrag!
  $promptResult: [InputPromptResult]
) {
  modifyShadowServiceContract(
    id: $id
    serviceContract: $serviceContract
    promptResult: $promptResult
  ) {
    ${SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_GQL}
  }
}
`;

export type ModifyShadowServiceContractObjectResponse = {
  modifyShadowServiceContract: ModifyShadowServiceContractResult;
};

export type ModifyShadowServiceContractObjectVars = {
  id: string | number;
  serviceContract?: InputWartungsvertrag;
  promptResult?: InputPromptResult[];
};

export type CreateShadowServiceContractObjectVars = {
  customerCode?: number;
  apCode?: number;
  serviceContractCode?: number;
  projectCode?: number;
  name?: string | null;
};

export type CreateShadowServiceContractObjectResponse = {
  createShadowServiceContract: ModifyShadowServiceContractResult;
};

export const MODIFY_SHADOW_SERVICE_CONTRACT_ADD_POSITION = gql`
  mutation ModifyShadowServiceContractAddPosition(
    $id: ID!
    $articleIds: [Int]
    $typeOfPosition: AddServiceContractPosTypeOfPos
    $defaultTypeOfBill: ServiceContractDefaultTypeOfBilling
    $copyPositions: [Int]
    $index: Int
    $defaultText: String
    $localId: String
  ) {
    modifyShadowServiceContractAddPosition( 
      id: $id
      articleCodes: $articleIds
      typeOfPosition: $typeOfPosition
      copyPositions: $copyPositions
      index: $index
      defaultText: $defaultText
      defaultTypeOfBill: $defaultTypeOfBill
      altId: $localId
    ) {
      ${SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_GQL}
    }
  }
`;

export type ModifyShadowServiceContractObjectAddComponentResponse = {
  modifyShadowServiceContractAddPosition: ModifyShadowServiceContractResult;
};

export type ModifyShadowServiceContractObjectAddComponentVars = {
  id: string;
  articleIds?: number[];
  typeOfPosition?: AddServiceContractPosTypeOfPos;
  defaultTypeOfBill?: ServiceContractDefaultTypeOfBilling;
  copyPositions?: number[];
  index?: number;
  defaultText?: string;
  localId?: string;
};

export const MODIFY_SHADOW_SERVICE_CONTRACT_MODIFY_POSITION = gql`
  mutation ModifyShadowServiceContractModifyPosition(
    $id: ID!
    $position: InputWartungsvertragPosition!
  ) {
    modifyShadowServiceContractModifyPosition(
      id: $id
      position: $position
    ) {
      ${SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_GQL}
    }
  }
`;

export type ModifyShadowServiceContractObjectModifyPositionResponse = {
  modifyShadowServiceContractModifyPosition: ModifyShadowServiceContractResult;
};

export type ModifyShadowServiceContractObjectModifyPositionVars = {
  id: string | number;
  position?: ServiceContractPosition;
};

export const MODIFY_SHADOW_SERVICE_CONTRACT_MOVE_POSITION = gql`
mutation ModifyShadowServiceContractMovePosition(
  $id: ID!
  $positionId: Int!
  $index: Int!
) {
  modifyShadowServiceContractMovePosition(
    id: $id
    positionCode: $positionId
    newIndex: $index  
  ) {
    ${SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_GQL}
  }
}
`;

export type ModifyShadowServiceContractObjectMovePositionResponse = {
  modifyShadowServiceContractMovePosition: ModifyShadowServiceContractResult;
};

export type ModifyShadowServiceContractObjectMovePositionVars = {
  id: string | number;
  positionId: number;
  index: number;
};

export const MODIFY_SHADOW_SERVICE_CONTRACT_REMOVE_POSITION = gql`
  mutation ModifyShadowServiceContractObjectRemovePosition($id: ID!, $positionIds: [Int]!) {
    modifyShadowServiceContractRemovePosition(id: $id, positionCodes: $positionIds) {
      ${SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_GQL}
    }
  }
`;

export type ModifyShadowServiceContractObjectRemovePositionResponse = {
  modifyShadowServiceContractRemovePosition: ModifyShadowServiceContractResult;
};

export type ModifyShadowServiceContractObjectRemovePositionVars = {
  id: string | number;
  positionIds: number[];
};

export const PERSIST_SHADOW_SERVICE_CONTRACT_OBJECT = gql`
  mutation PersistShadowServiceContract(
    $id: ID!
    $attachements: InputErpAnhangAttachementsRelation
  ) {
    persistShadowServiceContract(
      id: $id,
      removeShadowServiceContract: false,
      attachements: $attachements,
    ) {
      ${SHADOW_SERVICE_CONTRACT_OBJECT_RESPONSE_GQL}
    }
  }
`;

export type PersistShadowServiceContractObjectResponse = {
  persistShadowServiceContract: number;
};

export type PersistShadowServiceContractObjectVars = {
  id: string;
  attachements?: InputErpAnhangAttachementsRelation;
  relations?: BzObjectRelation;
};

export const DELETE_SHADOW_SERVICE_CONTRACT_OBJECT = gql`
  mutation DeleteShadowServiceContract($id: ID!) {
    deleteShadowServiceContract(id: $id)
  }
`;

export type DeleteShadowServiceContractObjectResponse = {
  deleteShadowServiceContract: ModifyShadowServiceContractResult;
};

export type DeleteShadowServiceContractObjectVars = {
  id: string | number;
};
